import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { change, Field, getFormValues, reduxForm } from 'redux-form/immutable';
import PropTypes from 'prop-types';
import { Map } from 'immutable';

import FormButton from '../FormButton';
import CustomModal from '../../components/CustomModal';
import HelpChat from '../../components/HelpChat';

import { renderFieldCheckbox, renderFieldRadio } from '../Form/renderField';
import { FORM_STEP1, FORM_STEP2, FORM_STEP3, FORM_STEP4 } from '../Form/actionCreator';
import {
	v_required,
} from '../Form/checkField';

import { HELPER_TIMEOUT, getPrivacyInfo, tcModalContent, privacyModalContent } from '../../utils/commonFormsConfig';
import { onSubmitFail } from '../../utils/commonFormsHandlers';
import { fakePaymentCountries } from '../Step2/utils';

/* eslint-disable */
const validate = values => {
	values = values.toJS();
	const errors = {};

	if (values.bankCountryCode && values.bankCountryCode.value === 'Italy') {
		if (values.codiceIBAN && values.codiceIBAN.length > 1) {
			if (values.codiceIBAN.substring(0, 2).toLowerCase() !== 'it') {
				errors.codiceIBAN = 'Codice IBAN non valido';
			}
		}
	} else {
		errors.codiceIBAN = '';
	}

	return errors;
};
/* eslint-enable */

class Step4 extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isModalTcOpen: false,
			isModalOpen: false,
			openHelpChat: false,
			countries: [],
			currentCountry: null
		};
	}

	componentDidMount() {
		setTimeout(() => {
			this.setState({ openHelpChat: true });
		}, HELPER_TIMEOUT);

		this.setState({ countries: fakePaymentCountries });
	}

	handleTcModal = () => {
		this.setState((prevState) => {
			return { isModalTcOpen: !prevState.isModalTcOpen };
		});
	};

	handlePrivacyModal = () => {
		this.setState((prevState) => {
			return { isModalOpen: !prevState.isModalOpen };
		});
	};

	setAddressInfo = (addressInfo) => {
		const country = addressInfo.filter(i => i.types.indexOf('country') !== -1);
		if (country.length) {
			this.setState({ currentCountry: country[0].short_name });
		}
	};

	/* eslint-disable */
	render() {
		const { isModalTcOpen, isModalOpen, openHelpChat, countries, currentCountry } = this.state;
		const { valuesStep1, valuesStep4, handleSubmit, change, t } = this.props;

		const values = valuesStep4 ? valuesStep4.toJS() : {};
		const step1 = valuesStep1 ? valuesStep1.toJS() : {};

		const isCountryIT = currentCountry === 'IT' || !currentCountry;

		const privacy = getPrivacyInfo(t);

		const consent_options = [
			{ value: 'yes', label: t('form.step4.agree') },
			{ value: 'no', label: t('form.step4.notAgree') }
		];


		return <div className='px-lg-4'>
			<form onSubmit={handleSubmit} noValidate>

				<div className='row'>
					<div className='form-group col'>
						<h4 className='mb-2'>{t('form.step4.paymentType_2')}</h4>
						<p className='text-lg'>
							{t('form.step4.paymentType_2_text_1')}
						</p>
						<p className='text-lg'>
							{t('form.step4.paymentType_2_text_2')}
						</p>
					</div>
				</div>

				{
					<Fragment>
						<div className='row'>
							<div className='col'>
								<h4 className='mb-2'>{t('form.step4.subtitle_3')}</h4>
							</div>
						</div>
						<div className='row'>
							<div className='form-group terms-and-condition col'>
								<div className='row'>
									<div className='col-auto'>
										<Field name='acceptTc' label={null} component={renderFieldCheckbox} validate={[(value) => v_required(value, t)]} />
									</div>
									<div className="col pt-4 px-md-0">
										<p className="text-lg">
											{t('form.step4.terms_and_conditions_text')} <a className='modal-link' onClick={this.handleTcModal}>{t('form.step4.terms_and_conditions_link')}</a>
										</p>
									</div>
								</div>
							</div>
						</div>
					</Fragment>
				}

				{
					<Fragment>
						<div className='row'>
							<div className='col'>
								<h4 className='mb-2'>{t('form.step4.subtitle_2')}</h4>
							</div>
						</div>
						<div className='row'>
							<div className='form-group privacy col'>
								<p className='text-lg'>
									{t('form.step4.privacy_text_1')} <a className='modal-link' onClick={this.handlePrivacyModal}>Privacy Policy</a> {t('form.step4.privacy_text_2')}
								</p>
							</div>
						</div>
						<div className='row'>
							<div className='form-group privacy col'>
								<div className='row'>
									<div className='col'>
										<p className='text-lg mt-4'>
											{privacy['authComunicazioniPromo']}
										</p>
									</div>
								</div>
								<div className='row'>
									<div className='col-sm-8 col-center'>
										<Field name='authComunicazioniPromo' options={consent_options} component={renderFieldRadio} centered={true} forceInline={true} inverted={true} validate={[(value) => v_required(value, t)]} />
									</div>
								</div>
							</div>
						</div>
						<div className='row'>
							<div className='form-group col'>
								<div className='row'>
									<div className='col'>
										<p className='text-lg mt-4'>
											{privacy['authProfilazioneUtente']}
										</p>
									</div>
								</div>
								<div className='row'>
									<div className='col-sm-8 col-center'>
										<Field name='authProfilazioneUtente' options={consent_options} component={renderFieldRadio} centered={true} forceInline={true} inverted={true} validate={[(value) => v_required(value, t)]} />
									</div>
								</div>
							</div>
						</div>
						<div className='row'>
							<div className='form-group col'>
								<div className='row'>
									<div className='col'>
										<p className='text-lg mt-4'>
											{privacy['authComunicazioneDati']}
										</p>
									</div>
								</div>
								<div className='row'>
									<div className='col-sm-8 col-center'>
										<Field name='authComunicazioneDati' options={consent_options} component={renderFieldRadio} centered={true} forceInline={true} inverted={true} validate={[(value) => v_required(value, t)]} />
									</div>
								</div>
							</div>
						</div>
					</Fragment>
				}

				<FormButton {...this.props}></FormButton>
			</form>
			<CustomModal isOpen={isModalTcOpen} hideModal={this.handleTcModal} currentTitle={tcModalContent.title} currentContent={tcModalContent.content} />
			<CustomModal isOpen={isModalOpen} hideModal={this.handlePrivacyModal} currentTitle={privacyModalContent.title} currentContent={privacyModalContent.content} />
			{openHelpChat && <HelpChat />}
		</div>;
	}
}

const defaultValues = {
	paymentType: '2',
	copyDebData: true,
	personType: '1',
	bankCountryCode: {
		value: 'Italy',
		label: 'Italy'
	}
};

const mapStateToProps = (state) => {
	return {
		initialValues: defaultValues,
		valuesStep1: getFormValues(FORM_STEP1)(state),
		valuesStep2: getFormValues(FORM_STEP2)(state),
		valuesStep3: getFormValues(FORM_STEP3)(state),
		valuesStep4: getFormValues(FORM_STEP4)(state) || new Map()
	};
};

const mapDispatchToProps = {
	change
};

Step4.propTypes = {
	handleSubmit: PropTypes.func,
	change: PropTypes.func,
	initialValues: PropTypes.object,
	valuesStep1: PropTypes.object,
	valuesStep2: PropTypes.object,
	valuesStep3: PropTypes.object,
	valuesStep4: PropTypes.object,

	t: PropTypes.func
};

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
	form: FORM_STEP4, // a unique name for this form
	destroyOnUnmount: false,
	onSubmitFail: (errors) => {
		onSubmitFail(errors);
	},
	validate
	// keepDirtyOnReinitialize: true,
	// enableReinitialize: true
	// validate,   // <--- validation function given to redux-form
	// warn        // <--- warning function given to redux-form
})(Step4));
